import { injectable, inject } from 'inversify';
import { UploadDispatcher } from '@dealroadshow/file-uploader';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import UsersUploadAdapter from '@/dataroom/infrastructure/api/FileUploadDispatcher/uploadAdapters/UsersUploadAdapter';
import UsersUploadStrategy
  from '@/dataroom/infrastructure/api/FileUploadDispatcher/uploadAdapters/uploadStrategy/UsersUploadStrategy';
import { DataroomTenantContextSymbol, type IDataroomTenantContext } from '@dataroom/tenant/types';
import { validateDataroomTenant } from '@dataroom/tenant/validateDataroomTenant';
import Container from '@framework/di/Container';

@injectable()
class UsersUploadDispatcherFactory {
  constructor(
    @inject(Container) private readonly container: Container,
  ) {}

  create = (dataroomName: string) => {
    const { tenant } = this.container.get<IDataroomTenantContext>(DataroomTenantContextSymbol);

    validateDataroomTenant(tenant);

    const usersUploadAdapter = new UsersUploadAdapter({
      url: dataroomUrl(tenant).getUsersUploadUrl(dataroomName),
    });

    return new UploadDispatcher(new UsersUploadStrategy(usersUploadAdapter));
  };
}

export default UsersUploadDispatcherFactory;
